import { getPreferredVideo } from "../../../Utils/media";
import "../style.css";

const VideoDisplay = ({ interactionState }) => {
  const VideoFiles = {
    idle: {
      safari: `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-idle+1.mov`,
      other: `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-idle+1.webm`,
    },
    userSpeaking: {
      safari: `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-listening+1.mov`,
      other: `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-listening+1.webm`,
    },
    arisSpeaking: {
      safari: `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-responding+1.mov`,
      other: `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-responding+1.webm`,
    },
  };

  const currentVideoFile = getPreferredVideo(
    VideoFiles[interactionState].other,
    VideoFiles[interactionState].safari
  );

  return (
    <div className="coaching-video-container">
      <div className="coaching-video-container-below">
        <video
          key={currentVideoFile}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          className="relationship-gif"
          src={currentVideoFile}
        />
        <div className="coaching-video-container-background" />
      </div>
    </div>
  );
};

export default VideoDisplay;
